"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Tableau Services APIs
 * Open API specification for Tableau Services APIs
 *
 * The version of the OpenAPI document: latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
const _1 = require("./");
/**
* @export
* @enum {string}
*/
var TableauNlpRefinementuiWidgetDateFilterWidgetResolutionEnum;
(function (TableauNlpRefinementuiWidgetDateFilterWidgetResolutionEnum) {
    TableauNlpRefinementuiWidgetDateFilterWidgetResolutionEnum["Undefined"] = "Undefined";
    TableauNlpRefinementuiWidgetDateFilterWidgetResolutionEnum["ExactDate"] = "ExactDate";
    TableauNlpRefinementuiWidgetDateFilterWidgetResolutionEnum["Year"] = "Year";
    TableauNlpRefinementuiWidgetDateFilterWidgetResolutionEnum["Month"] = "Month";
    TableauNlpRefinementuiWidgetDateFilterWidgetResolutionEnum["Quarter"] = "Quarter";
    TableauNlpRefinementuiWidgetDateFilterWidgetResolutionEnum["Week"] = "Week";
    TableauNlpRefinementuiWidgetDateFilterWidgetResolutionEnum["Day"] = "Day";
    TableauNlpRefinementuiWidgetDateFilterWidgetResolutionEnum["Hour"] = "Hour";
    TableauNlpRefinementuiWidgetDateFilterWidgetResolutionEnum["Minute"] = "Minute";
})(TableauNlpRefinementuiWidgetDateFilterWidgetResolutionEnum = exports.TableauNlpRefinementuiWidgetDateFilterWidgetResolutionEnum || (exports.TableauNlpRefinementuiWidgetDateFilterWidgetResolutionEnum = {}));
function TableauNlpRefinementuiWidgetDateFilterWidgetFromJSON(json) {
    return TableauNlpRefinementuiWidgetDateFilterWidgetFromJSONTyped(json, false);
}
exports.TableauNlpRefinementuiWidgetDateFilterWidgetFromJSON = TableauNlpRefinementuiWidgetDateFilterWidgetFromJSON;
function TableauNlpRefinementuiWidgetDateFilterWidgetFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'resolution': !runtime_1.exists(json, 'resolution') ? undefined : json['resolution'],
        'tableauFieldString': !runtime_1.exists(json, 'tableau_field_string') ? undefined : json['tableau_field_string'],
        'individual': !runtime_1.exists(json, 'individual') ? undefined : _1.TableauNlpRefinementuiWidgetDateFilterWidgetIndividualFromJSON(json['individual']),
        'relative': !runtime_1.exists(json, 'relative') ? undefined : _1.TableauNlpRefinementuiWidgetDateFilterWidgetRelativeFromJSON(json['relative']),
        'range': !runtime_1.exists(json, 'range') ? undefined : _1.TableauNlpRefinementuiWidgetDateFilterWidgetRangeFromJSON(json['range']),
        'isDatetime': !runtime_1.exists(json, 'is_datetime') ? undefined : json['is_datetime'],
        'nestedIndividual': !runtime_1.exists(json, 'nestedIndividual') ? undefined : json['nestedIndividual'],
        'nestedRelative': !runtime_1.exists(json, 'nestedRelative') ? undefined : json['nestedRelative'],
        'nestedRange': !runtime_1.exists(json, 'nestedRange') ? undefined : json['nestedRange'],
    };
}
exports.TableauNlpRefinementuiWidgetDateFilterWidgetFromJSONTyped = TableauNlpRefinementuiWidgetDateFilterWidgetFromJSONTyped;
function TableauNlpRefinementuiWidgetDateFilterWidgetToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'resolution': value.resolution,
        'tableau_field_string': value.tableauFieldString,
        'individual': _1.TableauNlpRefinementuiWidgetDateFilterWidgetIndividualToJSON(value.individual),
        'relative': _1.TableauNlpRefinementuiWidgetDateFilterWidgetRelativeToJSON(value.relative),
        'range': _1.TableauNlpRefinementuiWidgetDateFilterWidgetRangeToJSON(value.range),
        'is_datetime': value.isDatetime,
        'nestedIndividual': value.nestedIndividual,
        'nestedRelative': value.nestedRelative,
        'nestedRange': value.nestedRange,
    };
}
exports.TableauNlpRefinementuiWidgetDateFilterWidgetToJSON = TableauNlpRefinementuiWidgetDateFilterWidgetToJSON;
